import styled from 'styled-components/macro';
import { BG_GRADIENT_FROM_TRANSPARENT_TO_BLACK } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { HeadingLevel4, RegularTextLevel3 } from '@yme/tokens/typography';
import { getTextStyles, transformSrcSetToCss } from '@yme/utils/styles';
export const CardWrapperStyled = styled.div `
  min-width: 100%;

  ${({ srcSet, bgSrc }) => transformSrcSetToCss(srcSet, bgSrc, BG_GRADIENT_FROM_TRANSPARENT_TO_BLACK)}

  background-size: cover;
  background-position: 50%;
  min-height: 500px;
  height: 100%;

  ${ADAPTIVE.minWidth.tablet} {
    aspect-ratio: ${({ aspectRatioParams }) => aspectRatioParams.md};
    min-height: auto;
    height: auto;
  }

  ${ADAPTIVE.minWidth.desktop} {
    aspect-ratio: ${({ aspectRatioParams }) => aspectRatioParams.lg};
  }
`;
export const SubTitleStyled = styled(HeadingLevel4) `
  ${ADAPTIVE.minWidth.desktop} {
    ${getTextStyles(null, null, 14, 16)}
  }
`;
export const ContentStyled = styled(RegularTextLevel3) `
  display: -webkit-box;
  -webkit-line-clamp: ${({ countLineVisible = 4 }) => countLineVisible};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
